import React from 'react';

const IntroSection: React.FC = () => {
  return (
    <section 
      id="intro" 
      className="relative overflow-hidden"
    >
      {/* Background Layer - Dark color with grid */}
      <div className="absolute inset-0 bg-accent">
        <div className="hero-grid" aria-hidden="true" />
        <div className="section-grain" aria-hidden="true" />
      </div>
      
      {/* Main Content Layer - Transparent background */}
      <div className="relative py-24 md:py-32 lg:py-40">
        <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
          <div className="relative max-w-4xl mx-auto text-center">
            {/* Oval backdrop with radial gradient for text readability */}
            <div aria-hidden="true" className="intro-oval" />
            <div className="relative z-10 space-y-8">
              <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-bold animate-on-scroll leading-tight">
                <span className="block text-background">Simple Technology.</span>
                <span className="block mt-2 text-primary">Real Solutions.</span>
              </h2>
              <p className="text-base sm:text-lg md:text-xl text-background/90 animate-on-scroll max-w-3xl mx-auto leading-relaxed px-4" 
                 data-delay="0.2s">
                At Paokhum, we help NGOs, local institutions, and businesses go digital. From modern websites 
                to making your CCTV feeds secure and shareable online, we create solutions that are simple, 
                affordable, and future-ready.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
